module.exports = __webpack_public_path__ + "img/4.dec438a1.webp";